import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { MESSAGES_RESET } from './messages.const';
import messagesDetailReducer from './messagesDetail/messagesDetail.reducer';
import messagesListReducer from './messagesList/messagesList.reducer';
import recipientsReducer from './recipients/recipients.reducer';

const initialState = {};

const combinedReducers = combineReducers({
  detail: messagesDetailReducer,
  list: messagesListReducer,
  recipients: recipientsReducer,
});

const messagesRootReducer = createReducer(initialState, builder => {
  builder.addCase(MESSAGES_RESET, () => initialState).addDefaultCase(() => {});
});

export default (state = initialState, action) => {
  const newState = messagesRootReducer(state, action);
  return combinedReducers(newState, action);
};
